<!-- Textual Inputs -->
<mat-card class="daxa-card mb-25 border-radius bg-white border-none d-block">
    <mat-card-header>
        <mat-card-title>
            <h5 class="mt-0 mb-0">
                Locker
            </h5>
        </mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <form #lockerForm="ngForm">
            @if (locker) {
                <div class="mb-25">
                    <div class="row">
                        <div class="col col-4">
                            <mat-form-field class="mb-25">
                                <mat-label>Tipo Locker</mat-label>
                              <mat-select
                                    name="tenantType"
                                    [(ngModel)]="locker.tenantType"
                                    id="tenantType"
                                    (ngModelChange)="updateAccountTypeBasedOnTenant()"
                                >
                                <mat-option *ngFor="let type of lockerTypes"
                                            [value]="type">{{ getEnumDescription(type) }}
                                </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                      <div class="col col-4">
                        <mat-form-field class="mb-25"
                                        [ngClass]="{'error-select-custom': isFieldInvalid('idLockerAccount')}">
                          <mat-label>Account locker</mat-label>
                          <mat-select
                            name="idLockerAccount"
                            #idLockerAccount="ngModel"
                            [(ngModel)]="locker.idLockerAccount"
                            (selectionChange)="removeFromErrors('idLockerAccount')"
                            id="idLockerAccount"
                            required

                          >
                            <mat-option *ngFor="let user of userList"
                                        [value]="user.IDAccount">{{ user.nominativo }}
                            </mat-option>
                          </mat-select>
                          @if (isFieldInvalid('idLockerAccount')) {
                            <mat-hint class="text-danger">
                              <span>Account già utilizzato.</span>
                            </mat-hint>
                          }

                        </mat-form-field>

                      </div>
                      <div class="col col-4 justify-content-end text-right">
                        <label class="fw-bold mr-15">Stato del locker:</label>
                        <span
                          class="badge rounded-pill text-bg-daxa font-size-24">{{ getLockerStatusDescription(locker.lockerStatus) }}</span>
                      </div>

                    </div>
                    @if (checkTenantType()){
                        <div class="row">
                            <div class="col col-4">
                                <mat-form-field class="mb-25">
                                    <mat-label>Indirizzo Server</mat-label>
                                    <input
                                      #server='ngModel'
                                        matInput
                                        name="serverAddress"
                                        [(ngModel)]="locker.serverAddress"
                                      required
                                        minlength="3"
                                    >
                                    @if (server.hasError('required')) {
                                        <mat-error>L'indirizzo del server è <strong>obbligatorio</strong></mat-error>
                                    }
                                </mat-form-field>
                            </div>
                            <div class="col col-2">
                                <mat-form-field class="mb-25">
                                    <mat-label>ID Locker WIB</mat-label>
                                  <input
                                        #actualID='ngModel'
                                        matInput
                                        name="actualID"
                                        [(ngModel)]="locker.actualID"
                                        required
                                    >
                                    @if (actualID.hasError('required')) {
                                        <mat-error>L'ID Locker WIB è <strong>obbligatorio</strong></mat-error>
                                    }
                                </mat-form-field>
                            </div>
                            <div class="col col-3">
                                <mat-form-field class="mb-25">
                                    <mat-label>Username</mat-label>
                                  <input
                                        #username='ngModel'
                                        matInput
                                        name="username"
                                        [(ngModel)]="locker.username"
                                        required
                                    >
                                    @if (username.hasError('required')) {
                                        <mat-error>Lo Username è <strong>obbligatorio</strong></mat-error>
                                    }
                                </mat-form-field>
                            </div>
                            <div class="col col-3">
                                <mat-form-field class="mb-25">
                                    <mat-label>Password</mat-label>
                                  <input
                                        #password='ngModel'
                                        matInput
                                        name="password"
                                        [(ngModel)]="locker.password"
                                        required
                                    >
                                    @if (password.hasError('required')) {
                                        <mat-error>La password è <strong>obbligatoria</strong></mat-error>
                                    }
                                </mat-form-field>
                            </div>
                        </div>
                    } @else {
                        <div class="row">
                          <div class="col col-9">
                            <mat-form-field class="mb-25"
                                            [ngClass]="{'error-select-custom': isFieldInvalid('ip_address_server')}">
                                    <mat-label>Indirizzo IP Server</mat-label>
                                    <input
                                      #ip_address_server='ngModel'
                                        matInput
                                        [(ngModel)]="locker.ip_address_server"
                                      required
                                        minlength="3"
                                      name="ip_address_server"
                                      (ngModelChange)="removeFromErrors('ip_address_server')"
                                    >
                                    @if (ip_address_server.hasError('required')) {
                                        <mat-error>L'indirizzo IP del server è <strong>obbligatorio</strong></mat-error>
                                    }
                                </mat-form-field>
                            </div>
                          <div class="col col-3">
                                <mat-form-field class="mb-25">
                                    <mat-label>Porta server</mat-label>
                                    <input
                                      #port_server='ngModel'
                                        matInput
                                        name="port_server"
                                        [(ngModel)]="locker.port_server"
                                      required
                                        minlength="3"
                                    >
                                    @if (port_server.hasError('required')) {
                                        <mat-error>La porta del server è <strong>obbligatoria</strong></mat-error>
                                    }
                                </mat-form-field>
                            </div>

                        </div>
                    }
                    <div class="row">
                        <div class="col col-4">
                            <mat-form-field class="mb-25">
                                <mat-label>Indirizzo</mat-label>
                                <input
                                  #address='ngModel'
                                    matInput
                                    name="address"
                                    [(ngModel)]="locker.location.address"
                                  required
                                    minlength="3"
                                >
                                @if (address.hasError('required')) {
                                    <mat-error>L'indirizzo è <strong>obbligatorio</strong></mat-error>
                                }
                            </mat-form-field>
                        </div>
                        <div class="col col-4">
                            <mat-form-field class="mb-25">
                                <mat-label>Città</mat-label>
                                <input
                                  #city='ngModel'
                                    matInput
                                    name="city"
                                    [(ngModel)]="locker.location.city"
                                    minlength="3"
                                >
                            </mat-form-field>
                        </div>
                        <div class="col col-4">
                            <mat-form-field class="mb-25">
                                <mat-label>Provincia</mat-label>
                                <input
                                  #province='ngModel'
                                  matInput
                                    name="province"
                                    [(ngModel)]="locker.location.province"
                                    minlength="2"
                                    maxlength="2"
                                >
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col col-4">
                            <mat-form-field class="mb-25">
                                <mat-label>Cap</mat-label>
                                <input
                                  #cap='ngModel'
                                    matInput
                                    name="cap"
                                    [(ngModel)]="locker.location.cap"
                                    minlength="3"
                                >
                            </mat-form-field>
                        </div>
                        <div class="col col-4">
                            <mat-form-field class="mb-25">
                                <mat-label>Latitudine</mat-label>
                                <input
                                  #latitude='ngModel'
                                  matInput
                                    name="latitude"
                                  [(ngModel)]="locker.location.latitude"
                                    minlength="3"
                                >
                            </mat-form-field>
                        </div>
                        <div class="col col-4">
                            <mat-form-field class="mb-25">
                              <mat-label>Longitudine</mat-label>
                                <input
                                  #longitude='ngModel'
                                  matInput
                                    name="longitude"
                                  [(ngModel)]="locker.location.longitude"
                                    minlength="3"
                                >
                            </mat-form-field>
                        </div>
                    </div>
                </div>
            }
            <mat-divider class="mb-25"></mat-divider>
            <mat-card-footer>
                <div class="row d-flex flex-row">
                    <div class="footer-buttons d-flex col-9">
                      <button mat-raised-button color="primary" class="btn "
                              (click)="configureLocker()"
                              [disabled]="locker.IDLockerRacc===0">
                        <mat-icon>settings</mat-icon>
                        Configura
                      </button>
                        <button mat-raised-button color="warn" class="btn " [routerLink]="['/lockers']">
                            <mat-icon>close</mat-icon>
                            Annulla
                        </button>
                        <button type="submit" mat-raised-button class="btn daxa"
                                [disabled]="lockerForm.invalid"
                                (click)="onSubmitForm(lockerForm)">
                            <mat-icon>check</mat-icon>
                            Salva e chiudi
                        </button>
                    </div>
                </div>
            </mat-card-footer>
        </form>
    </mat-card-content>
</mat-card>



